import React from "react";
import PropTypes from "prop-types";

import pointsIcon from "../assets/images/plan/points.svg";
import benefitsIcon from "../assets/images/plan/benefits.svg";
import subscriptionIcon from "../assets/images/plan/subscription.svg";

import { PLAN_TYPE_ENUM } from "../constants/planConstants";

import "../assets/styles/PlanSelect.scss";
import { getMessage } from "../messages";

const OnBoardingSelectPlan = (props) => {
  const PlanCard = (props) => {
    return (
      <div className="e-card e-card-no_checkerboard text-align-left">
        <div className="e-card__content">
          <img className="e-card__preview" src={props.image} alt="" />
        </div>
        <div className="e-card__lead">
          <div className="e-card__caption">
            <div className="e-card__title">{props.title}</div>
          </div>
          <div className="e-card__description">{props.description}</div>
          <div className="e-card__footer">
            {props.planType ? (
              <a className="e-btn e-btn-fullwidth e-btn-primary" onClick={() => props.onPlanSelect(props.planType)}>
                {getMessage("createGroupPopup.selectPlan.label")}
              </a>
            ) : null}
          </div>
        </div>
        {props.roadmap ? (
          <div className="l-roadmap-overlay">
            <div className="e-label e-label-secondary">{getMessage("onBoardingSelectPlan.readmap.title")}</div>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className="l-plan-select text-align-center e-box">
      <h2>{getMessage("onBoardingSelectPlan.title")}</h2>

      <div>{getMessage("onBoardingSelectPlan.content")}</div>

      <div className="l-plan-cards-wrapper">
        <div>
          <PlanCard
            {...props}
            planType={PLAN_TYPE_ENUM.POINTS}
            image={pointsIcon}
            title={getMessage("onBoardingSelectPlan.points")}
          />
        </div>
        <div>
          <PlanCard {...props} image={benefitsIcon} title={getMessage("onBoardingSelectPlan.spend")} roadmap={true} />
        </div>
        <div>
          <PlanCard
            {...props}
            image={subscriptionIcon}
            title={getMessage("onBoardingSelectPlan.subscription")}
            roadmap={true}
          />
        </div>
      </div>

      <div className="text-color-shade">{getMessage("onBoardingSelectPlan.notice")}</div>
    </div>
  );
};

OnBoardingSelectPlan.propTypes = {
  onPlanSelect: PropTypes.func.isRequired
};

export default OnBoardingSelectPlan;
